import axios, { AxiosError, AxiosResponse } from "axios";
import packageJson from "../../package.json";
import { AppLog } from "services";
import { StatusMsg } from "./enum/StatusMsgJK";
import { Service } from "./services";

interface RequestApiParams {
  data?: any;
  method?: string;
  headers?: Record<string, string>;
}

export const RequestApi = async (url: string, { data = "", method = "POST", headers }: RequestApiParams = {}): Promise<any> => {
  let hearderRequest = {};
  let newData = { ...data, ...{ version_no: `${packageJson.version}` } };

  if (!headers) {
    const browserId = Service.authenticationKey;
    if (browserId) {
      hearderRequest = {
        Authorization: `Bearer ${browserId}`,
      };
    }
  } else {
    hearderRequest = { ...headers };
  }
  const headersList = {
    Accept: "*/*",
    "Content-Type": "application/json",
    ...hearderRequest,
  };
  try {
    const response: AxiosResponse = await axios({
      url,
      data: newData,
      method,
      headers: headersList,
    });

    if (response.status === 200) {
      return response.data;
    } else {
      return {
        status: "failed",
        msg: `Code[${response.status}] can not request'`,
        "response.status": response.status,
      };
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      AppLog.show({ message: axiosError.message, status: StatusMsg.error });

      return {
        msg: axiosError.message,
        status: "error",
      };
    }
    return {
      status: "failed",
      message: "An unexpected error occurred",
    };
  }
};

export const RequestApiDisableHead = async (url: string, { data = {}, method = "POST" }) => {
  return axios({
    url,
    data,
    method,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};
